import { render } from "./Transportation.vue?vue&type=template&id=50d64210&scoped=true"
import script from "./Transportation.vue?vue&type=script&lang=js"
export * from "./Transportation.vue?vue&type=script&lang=js"

import "./Transportation.vue?vue&type=style&index=0&id=50d64210&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d64210"]])

export default __exports__